import type { ReactNode } from 'react';
import './components.css';

type PillTone = 'hot' | 'warm' | 'cold' | 'offline' | 'online';

export function Pill({ tone, children }: { tone: PillTone; children: ReactNode }) {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}
